import { DatePicker } from "./DatePicker";
import { useReports } from "../utils/ReportsProvider";
import { useGetReportsQuery } from "../../../services/reportsApi";
import { useEffect, useState } from "react";
import { t } from "i18next";

export const ReportsHeader = () => {
  const { dateRange, setDateRange, setApiDateRange } = useReports();

  // Initialize default date range on component mount
  useEffect(() => {
    if (!dateRange) {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 30);

      const formatDate = (date: Date) => {
        const day = date.getDate();
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const year = date.getFullYear().toString().slice(-2);
        return `${day} ${month} ${year}`;
      };

      const defaultRange = `${formatDate(thirtyDaysAgo)} — ${formatDate(today)}`;
      setDateRange(defaultRange);
      handleDateRangeChange(defaultRange);
    }
  }, []);

  const handleDateRangeChange = (range: string) => {
    setDateRange(range);

    const parts = range.split(" — ");
    if (parts.length === 2) {
      const parseDate = (dateStr: string) => {
        const [day, month, year] = dateStr.split(" ");
        const monthMap: { [key: string]: string } = {
          Jan: "01",
          Feb: "02",
          Mar: "03",
          Apr: "04",
          May: "05",
          Jun: "06",
          Jul: "07",
          Aug: "08",
          Sep: "09",
          Oct: "10",
          Nov: "11",
          Dec: "12",
        };
        const fullYear = `20${year}`;
        return `${fullYear}-${monthMap[month]}-${day.padStart(2, "0")}`;
      };

      setApiDateRange({
        start_date: parseDate(parts[0]),
        end_date: parseDate(parts[1]),
      });
    }
  };
  const [showStillHere, setShowStillHere] = useState(false);
  const {
    data: reportsData,
    isLoading,
    refetch,
  } = useGetReportsQuery(undefined, {
    pollingInterval: showStillHere ? 0 : 180000, // 3 minutes, stop when modal is active
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowStillHere(true);
    }, 500000); // 8.5 minutes

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="">
      <div className="mb-4 flex items-center justify-between">
        <h4 className="text-3xl" style={{ color: "#1C67AD" }}>
          {t("reports.dashboard")}
        </h4>
        <DatePicker dateRange={dateRange} onDateRangeChange={handleDateRangeChange} />
      </div>
      <div style={{ color: "#1C67AD" }}>
        <span className="text-lg">{t("reports.realtimeActiveUsers")}: </span>
        <span className="text-lg font-bold">{isLoading ? "..." : reportsData?.realtime_active_clients_count || 0}</span>
      </div>
      <div style={{ color: "#1C67AD" }}>
        <span className="text-lg">{t("reports.realtimeActiveGuests")}: </span>
        <span className="text-lg font-bold">
          {isLoading ? "..." : reportsData?.realtime_active_guest_client_count || 0}
        </span>
      </div>
      <div style={{ color: "#1C67AD" }}>
        <span className="text-lg">{t("reports.realtimeActiveClients")}: </span>
        <span className="text-lg font-bold">
          {isLoading ? "..." : reportsData?.realtime_active_registered_client_count || 0}
        </span>
      </div>
      {showStillHere && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white p-6 shadow-lg">
            <p className="mb-4">{t("reports.areYouStillHere")}</p>
            <button
              onClick={() => setShowStillHere(false)}
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              {t("reports.yesImHere")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
